import { GetStaticPropsContext, InferGetStaticPropsType, NextPage } from 'next';

import { Duration } from 'constants/duration.constants';
import { seoTitleSuffixQuery } from 'queries/global/queries';
import Prefetcher from 'services/prefetcher';

import AccountTicketsContainer from 'components/@account/AccountTicketsContainer';
import AppNavigation from 'components/@navigation/AppNavigation';
import BasicSeo from 'components/@seo/BasicSeo';

const AccountTickets: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = ({ seoTitleSuffix }) => {
  return (
    <AppNavigation hideFooterOnMobile>
      <BasicSeo
        titleSuffix={seoTitleSuffix}
        titleIntlId="seo.account.tickets.title"
      />
      <AccountTicketsContainer />
    </AppNavigation>
  );
};

export default AccountTickets;

export const getStaticProps = async ({
  locale,
  preview,
}: GetStaticPropsContext) => {
  const prefetcher = await Prefetcher.init({ locale, preview });
  const { seoTitleSuffix } = await prefetcher.prefetch(seoTitleSuffixQuery);

  return {
    props: {
      seoTitleSuffix,
      dehydratedState: prefetcher.dehydratedState,
    },
    revalidate: Duration.TEN_MIN,
  };
};
